import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CheckCircle, Package, Home } from 'lucide-react';

const OrderSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { orderId, paymentId } = location.state || {};

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        <div className="bg-white rounded-3xl shadow-2xl p-12">
          <div className="w-24 h-24 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6 animate-bounce">
            <CheckCircle className="w-16 h-16 text-white" />
          </div>
          
          <h1 className="text-4xl font-bold text-gray-900 mb-4" style={{fontFamily: 'Fredoka, sans-serif'}}>
            Order Placed Successfully! 🎉
          </h1>
          
          <p className="text-xl text-gray-600 mb-8">
            Thank you for your purchase! Your healthy snacks are on the way.
          </p>

          {orderId && (
            <div className="bg-gray-50 rounded-xl p-6 mb-8">
              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Order ID:</span>
                  <span className="font-mono text-sm">{orderId}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Payment ID:</span>
                  <span className="font-mono text-sm">{paymentId}</span>
                </div>
              </div>
            </div>
          )}

          <div className="space-y-4">
            <Button
              onClick={() => navigate('/')}
              className="w-full bg-orange-500 hover:bg-orange-600 text-white py-6 text-lg"
            >
              <Home className="mr-2 w-5 h-5" />
              Continue Shopping
            </Button>
            
            <p className="text-sm text-gray-500">
              <Package className="w-4 h-4 inline mr-1" />
              We'll send you an email with tracking details soon!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;
